'use strict'

import {
  I18N_HU
} from './portal-i18n-hu.js'
import {
  PORTAL_PRESETS
} from './portal-presets.js'
import {
  showPortalPropContextMenu
} from './portal-prop-context-bridge.js'

const _ = window._
const $ = window.jQuery
const KML_ACTION_PRESETS = Array.isArray(PORTAL_PRESETS?.actions?.kml) ? PORTAL_PRESETS.actions.kml : []

const fnT = function (key, fallback) {
  const k = String(key || '').trim()
  if (!k) return String(fallback || '')
  if (Object.prototype.hasOwnProperty.call(I18N_HU, k)) return String(I18N_HU[k])
  return String(fallback || k)
}

const fnTF = function (key, vars, fallback) {
  const text = fnT(key, fallback)
  const data = (vars && typeof vars === 'object') ? vars : {}
  return text.replace(/\{([a-zA-Z0-9_]+)\}/g, function (_m, p1) {
    return Object.prototype.hasOwnProperty.call(data, p1) ? String(data[p1]) : ''
  })
}

const fnResolveI18Text = function (rawText, fallback) {
  const raw = String(rawText || '').trim()
  if (!raw) return String(fallback || '')
  const likelyKey = /^[a-z0-9_.-]+$/i.test(raw)
  if (!likelyKey) return raw
  const missingSentinel = '__PORTAL_I18N_MISSING__'
  const translated = fnT(raw, missingSentinel)
  if (translated !== missingSentinel) return translated
  return String(fallback || '')
}

const fnResolvePropValueHelp = function (_path, pathNoNs, value, fallbackTooltip) {
  if (typeof window !== 'undefined' && typeof window.PORTAL_RESOLVE_PROP_VALUE_HELP === 'function') {
    return window.PORTAL_RESOLVE_PROP_VALUE_HELP(_path, pathNoNs, value, fallbackTooltip)
  }
  const val = String(value || '').trim()
  const fallbackPath = String(pathNoNs || _path || '').trim()
  const tipRaw = String(fallbackTooltip || '').trim()
  const tip = fnResolveI18Text(tipRaw, '')
  if (tip) return tip
  if (tipRaw && !/^[a-z0-9_.-]+$/i.test(tipRaw)) return tipRaw
  return fnTF('dji.value_set', { field: fallbackPath, value: val }, fallbackPath + ': ' + val)
}

const fnShowPropContextMenu = function (event, _data) {
  showPortalPropContextMenu(event, _data)
}

const fnNormalizeKmlActionEntry = function (entry) {
  if (entry === null || entry === undefined) return null
  if (typeof entry === 'string' || typeof entry === 'number' || typeof entry === 'boolean') {
    const text = String(entry).trim()
    if (!text) return null
    return { text: text, param: '' }
  }
  if (typeof entry === 'object') {
    const rawText = (entry.text !== undefined && entry.text !== null)
      ? entry.text
      : ((entry._text !== undefined && entry._text !== null) ? entry._text : '')
    const text = String(rawText).trim()
    if (!text) return null
    const rawParam = (entry.param !== undefined && entry.param !== null)
      ? entry.param
      : ((entry['@param'] !== undefined && entry['@param'] !== null) ? entry['@param'] : '')
    const param = String(rawParam).trim()
    return { text: text, param: param }
  }
  return null
}

const fnGetKmlActionPreset = function (actionText) {
  const text = String(actionText || '').trim()
  if (!text) return null
  return KML_ACTION_PRESETS.find((item) => String(item && item.value || '').trim() === text) || null
}

const renderKmlActionsEditor = function ($container, initialActions, onChange) {

    const state = {
      actions: (Array.isArray(initialActions) ? initialActions : [])
        .map(fnNormalizeKmlActionEntry)
        .filter((item) => !!item)
    }

    const fnEmit = function () {
      if (typeof onChange === 'function') onChange(state.actions.slice())
    }

    const fnCreatePresetBadgeWrap = function (opts) {
      const o = _.assign({
        value: '',
        values: [],
        tooltipByValue: {},
        helpByValue: {},
        fieldPath: '',
        fieldLabel: '',
        fieldHelpShort: '',
        fieldHelpDetailed: '',
        editTooltip: fnT('action.custom_value_edit'),
        onApply: function () {},
        onInput: function () {}
      }, opts || {})
      const $host = $('<div class="mt-1"></div>')
      const $input = $('<input type="text" class="form-control form-control-sm d-none">').val(String(o.value || ''))
      const $wrap = $('<div class="d-flex flex-wrap gap-1 mt-1"></div>')
      const $editBtn = $('<button type="button" class="badge fw-normal text-bg-secondary border-0 py-1 px-2"></button>')
        .html('<i class="fa-solid fa-pen"></i>')
        .css('cursor', 'pointer')
        .attr('title', String(o.editTooltip || ''))
        .attr('data-bs-toggle', 'tooltip')
        .attr('data-bs-placement', 'top')
      $wrap.append($editBtn)
      let $buttons = $()
      ;(Array.isArray(o.values) ? o.values : []).forEach((val) => {
        const v = String(val || '').trim()
        if (!v) return
        const tip = String((o.tooltipByValue && o.tooltipByValue[v]) || '').trim() || fnTF('action.set_value_to', { value: v })
        const detailedHelp = String((o.helpByValue && o.helpByValue[v]) || '').trim() || tip
        const $btn = $('<button type="button" class="badge fw-normal border border-secondary bg-light text-dark py-1 px-2"></button>')
          .attr('data-value', v)
          .text(v)
          .css('cursor', 'pointer')
          .attr('title', tip)
          .attr('data-bs-toggle', 'tooltip')
          .attr('data-bs-placement', 'top')
        $btn.on('contextmenu', function (event) {
          fnShowPropContextMenu(event, {
            label: String(o.fieldLabel || o.fieldPath || fnT('common.value')),
            fullName: String(o.fieldPath || o.fieldLabel || ''),
            helpShort: tip,
            helpDetailed: detailedHelp
          })
        })
        $wrap.append($btn)
        $buttons = $buttons.add($btn)
      })
      const fnSyncActive = function () {
        const cur = String($input.val() || '').trim()
        $buttons.each(function () {
          const $btn = $(this)
          const rawBtnValue = $btn.data('value')
          const btnValue = (rawBtnValue === undefined || rawBtnValue === null) ? '' : rawBtnValue
          const isActive = String(btnValue).trim() === cur
          $btn.toggleClass('bg-primary', isActive)
          $btn.toggleClass('text-white', isActive)
          $btn.toggleClass('bg-light', !isActive)
          $btn.toggleClass('text-dark', !isActive)
        })
      }
      $editBtn.on('click', function () {
        const isHidden = $input.hasClass('d-none')
        $input.toggleClass('d-none', !isHidden)
        if (isHidden) $input.trigger('focus')
      })
      $wrap.on('click', '[data-value]', function () {
        const rawValue = $(this).data('value')
        const v = String((rawValue === undefined || rawValue === null) ? '' : rawValue).trim()
        $input.val(v)
        fnSyncActive()
        o.onApply(v)
      })
      $input.on('input', function () {
        fnSyncActive()
        o.onInput(String($input.val() || ''))
      })
      fnSyncActive()
      $host.append($input).append($wrap)
      return { $root: $host, $input: $input, sync: fnSyncActive }
    }

    const fnRender = function () {
      $container.empty()
      const $head = $('<div class="d-flex justify-content-between align-items-center mt-2 mb-1"></div>')
      $head.append($('<div class="small fw-semibold text-muted"></div>').text(fnT('action.kml.title')))
      const $addBtn = $('<button type="button" class="btn btn-sm btn-outline-primary"></button>').html('<i class="fa-solid fa-plus me-1"></i>' + fnT('action.add'))
      $head.append($addBtn)
      $container.append($head)

      if (!state.actions.length) {
        $container.append($('<div class="small text-muted mb-2"></div>').text(fnT('action.none')))
      }

      state.actions.forEach((action, idx) => {
        const $row = $('<div class="border rounded p-2 mb-2"></div>')
        const $top = $('<div class="d-flex align-items-center justify-content-between mb-1"></div>')
        $top.append($('<div class="small fw-semibold"></div>').text(fnTF('action.item', { n: idx + 1 })))
        const $ops = $('<div class="d-flex gap-1"></div>')
        const $up = $('<button type="button" class="badge text-bg-light border border-secondary">↑</button>').css('cursor', 'pointer')
        const $down = $('<button type="button" class="badge text-bg-light border border-secondary">↓</button>').css('cursor', 'pointer')
        const $del = $('<button type="button" class="badge text-bg-danger border-0"></button>').text(fnT('action.delete')).css('cursor', 'pointer')
        if (idx === 0) $up.prop('disabled', true).addClass('opacity-50')
        if (idx === state.actions.length - 1) $down.prop('disabled', true).addClass('opacity-50')
        $ops.append($up).append($down).append($del)
        $top.append($ops)
        $row.append($top)

        const actionValues = KML_ACTION_PRESETS.map((item) => String(item.value || '').trim()).filter(Boolean)
        const actionTooltipMap = {}
        KML_ACTION_PRESETS.forEach((item) => {
          const key = String(item && item.value || '').trim()
          if (!key) return
          actionTooltipMap[key] = fnResolveI18Text(String(item.tooltip || '').trim(), '')
        })
        $row.append($('<div class="small text-muted"></div>').text(fnT('action.type')))
        const actionPicker = fnCreatePresetBadgeWrap({
          value: action.text,
          values: actionValues,
          tooltipByValue: actionTooltipMap,
          fieldPath: 'ExtendedData.mis:actions._text',
          fieldLabel: fnT('action.type'),
          fieldHelpShort: fnT('action.type_help_short'),
          fieldHelpDetailed: fnT('action.type_help_detailed'),
          helpByValue: actionValues.reduce(function (acc, v) {
            acc[v] = fnResolvePropValueHelp('ExtendedData.mis:actions._text', 'ExtendedData.mis:actions._text', v, actionTooltipMap[v])
            return acc
          }, {}),
          editTooltip: fnT('action.edit_custom_text'),
          onApply: function (v) {
            action.text = v
            const preset = fnGetKmlActionPreset(v)
            if (preset && Array.isArray(preset.paramPresets) && preset.paramPresets.length && !action.param) {
              action.param = String(preset.paramPresets[0])
            }
            fnRender()
            fnEmit()
          },
          onInput: function (v) {
            action.text = v
            fnEmit()
          }
        })
        $row.append(actionPicker.$root)

        const selectedPreset = fnGetKmlActionPreset(action.text)
        const paramValues = (selectedPreset && Array.isArray(selectedPreset.paramPresets))
          ? selectedPreset.paramPresets.map((v) => String(v || '').trim()).filter(Boolean)
          : []
        const paramTooltipMap = {}
        paramValues.forEach((v) => {
          paramTooltipMap[v] = (selectedPreset && selectedPreset.paramTooltip)
            ? String(selectedPreset.paramTooltip)
            : (fnTF('action.param_value', { value: v }))
        })
        $row.append($('<div class="small text-muted mt-2"></div>').text(fnT('action.param')))
        const paramPicker = fnCreatePresetBadgeWrap({
          value: action.param,
          values: paramValues,
          tooltipByValue: paramTooltipMap,
          fieldPath: 'ExtendedData.mis:actions.@param',
          fieldLabel: fnT('action.param'),
          fieldHelpShort: fnT('action.param_help_short'),
          fieldHelpDetailed: fnT('action.param_help_detailed'),
          helpByValue: paramValues.reduce(function (acc, v) {
            acc[v] = fnResolvePropValueHelp('ExtendedData.mis:actions.@param', 'ExtendedData.mis:actions.@param', v, paramTooltipMap[v])
            return acc
          }, {}),
          editTooltip: fnT('action.edit_custom_param'),
          onApply: function (v) {
            action.param = v
            fnEmit()
          },
          onInput: function (v) {
            action.param = v
            fnEmit()
          }
        })
        $row.append(paramPicker.$root)

        $up.on('click', function () {
          if (idx <= 0) return
          const t = state.actions[idx - 1]
          state.actions[idx - 1] = state.actions[idx]
          state.actions[idx] = t
          fnRender()
          fnEmit()
        })
        $down.on('click', function () {
          if (idx >= state.actions.length - 1) return
          const t = state.actions[idx + 1]
          state.actions[idx + 1] = state.actions[idx]
          state.actions[idx] = t
          fnRender()
          fnEmit()
        })
        $del.on('click', function () {
          state.actions.splice(idx, 1)
          fnRender()
          fnEmit()
        })

        $container.append($row)
      })

      $addBtn.on('click', function () {
        const firstPreset = KML_ACTION_PRESETS[0] || null
        state.actions.push({
          text: firstPreset ? String(firstPreset.value || '') : '',
          param: (firstPreset && Array.isArray(firstPreset.paramPresets) && firstPreset.paramPresets.length)
            ? String(firstPreset.paramPresets[0] || '')
            : ''
        })
        fnRender()
        fnEmit()
      })
    }

    fnRender()
  }

export {
  renderKmlActionsEditor,
  fnNormalizeKmlActionEntry as normalizeKmlActionEntry,
  fnGetKmlActionPreset as getKmlActionPreset
}
